import { render } from "./PublicationAiAppCourseDescription.vue?vue&type=template&id=74e441c3&lang=true"
import script from "./PublicationAiAppCourseDescription.vue?vue&type=script&lang=js"
export * from "./PublicationAiAppCourseDescription.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__